@if (product(); as item) {

  <div class="product-detail-container">

    <div [ngStyle]="item.imageUrl | bgUrl" class="hero-section"></div>

    <div class="content-card">
      <div class="card-header">
        <div class="title-group">
          <span class="category-tag">Seleccionado para ti</span>
          <h1 class="product-name">{{ item.name }}</h1>
        </div>
      </div>

      <div class="price-section">
        <span class="label">Precio del producto</span>
        <span class="value">{{ item.price | clpFormat }}</span>
      </div>

      <div class="description-section">
        <h3>Información</h3>
        <p>{{ item.description || 'Disfruta de nuestra exclusiva preparación con granos seleccionados y la temperatura ideal para resaltar cada nota de sabor.' }}</p>
      </div>
    </div>
    <footer class="view-footer anim-slide-in-up">
      <button (click)="addToCart(item, $event)" class="btn-main accent">
        <div class="row-spread">
          <span>Añadir al pedido</span>
          <span class="price-badge">{{ item.price | clpFormat }}</span>
        </div>
      </button>
    </footer>

  </div>
}
